import {Icon} from 'src/Icon'
import {HStack, VStack} from './Stack'
import {Text} from './Text'

export const LeaderboardStat = ({
  icon,
  value,
  valueDim,
  description,
  large = false,
}) => {
  return (
    <div
      className={`leaderboard-stats-box ${
        large ? 'leaderboard-stats-box--large' : ''
      }`}
    >
      <VStack gap={0}>
        <div className="leaderboard-stats-box__icon">
          <Icon
            name={icon}
            color="var(--clr-brand)"
            size={large ? 24 : 20}
            marginRight="0"
          />
        </div>
        <HStack gap="0.5rem">
          <Text
            mono={false}
            size={large ? 3 : 2}
            weight={700}
            appearance="primary"
          >
            {value}
          </Text>

          {valueDim && (
            <Text
              mono={false}
              size={large ? 3 : 2}
              weight={500}
              appearance="secondary"
            >
              {valueDim}
            </Text>
          )}
        </HStack>
        <Text
          mono={false}
          size={large ? 1 : 0}
          weight={500}
          appearance="tertiary"
          align="center"
        >
          {description}
        </Text>
      </VStack>
    </div>
  )
}
